class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('.search-modal');
    this.searchInput = this.querySelector('.search__input');

    this.searchInput.addEventListener('click', this.onSearchInput.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('DOMContentLoaded', this.onDocumentLoad.bind(this));
  }

  onSearchInput(event) {
    event.preventDefault();
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('.search-modal').setAttribute('data-selected', true);
  }

  onBodyClickEvent(event) {
    this.detailsContainer.removeAttribute('data-selected');
  }

  onDocumentClick(event) {
    if (!this.searchInput.contains(event.target) && this.searchInput.value === '') {
      this.detailsContainer.removeAttribute('data-selected');
      this.detailsContainer.querySelectorAll('input')[0].blur();
    }
  }

  onDocumentLoad() {
    if (this.searchInput.value !== '') {
      this.detailsContainer.setAttribute('data-selected', true);
    }
  }
}

customElements.define('details-modal', DetailsModal);
